export tag Nav
	<self>
		<header.header [c: white]>
			<nav.inner>
				<a [c:inherit] route-to="/">
					<strong> "HN"
				<a [c:inherit] route-to="/newest/1">
					<strong> "New"
				<a [c:inherit] route-to="/show/1">
					<strong> "Show"
				<a [c:inherit] route-to="/ask/1">
					<strong> "Ask"
				<a [c:inherit] route-to="/jobs/1">
					<strong> "Jobs"
				<a.github href="http://github.com/solidjs/solid" target="_blank" rel="noreferrer"> "Built with Imba"